import type { CSSProperties } from "react";
import {
  Container,
  Lead,
  ProductTile,
  Rich,
  Section,
  SectionTitle,
  Watermark,
  Eyebrow,
} from "@vcn/ui";
import { useContent } from "../content";

export function Hero() {
  const { hero } = useContent();

  return (
    <section className="relative pt-[clamp(7rem,17vw,16rem)] pb-10 sm:pb-14">
      <Container className="text-center">
        {/*
          Wasserzeichen und Kachel stehen im Entwurf in einem festen
          Größenverhältnis: 1646 zu 442 Einheiten auf dem Desktop, 404 zu 160
          mobil. Deshalb hängen beide an derselben Variablen `--tile-w`.
        */}
        <div
          className="relative mx-auto mb-20 w-fit sm:mb-24 lg:mb-26"
          style={{ '--tile-w': 'clamp(12rem, 30vw, 20rem)' } as CSSProperties}
        >
          {/*
            Mobil bleibt der zweizeilige Schriftzug mittig hinter der Kachel:
            der Hero ist dort deutlich flacher als im Entwurf, ein Hochziehen
            schöbe „CARRIER“ unter die Kopfzeile.
          */}
          <Watermark
            brand="carrierhub"
            className="w-[calc(var(--tile-w)*2.524)] lg:w-[calc(var(--tile-w)*3.723)] lg:[--wm-shift:calc(var(--tile-w)*-0.312)]"
          />
          <ProductTile
            brand="carrierhub"
            width="var(--tile-w)"
            glow
            float
            decorative
          />
        </div>

        <h1 className="vcn-headline-gradient mx-auto max-w-3xl text-3xl leading-tight font-bold text-balance sm:text-4xl lg:text-[2.6rem]">
          {hero.title.map((line) => (
            <span key={line} className="block sm:inline sm:after:content-['_']">
              {line}
            </span>
          ))}
        </h1>
      </Container>
    </section>
  );
}

export function Intro() {
  const { intro } = useContent();

  return (
    <Section id="ueberblick" className="scroll-mt-20 pt-10 sm:pt-16">
      <Container className="text-center">
        <Eyebrow>{intro.eyebrow}</Eyebrow>

        <SectionTitle className="mt-4">
          {intro.title.map((line) => (
            <span key={line} className="block">
              {line}
            </span>
          ))}
        </SectionTitle>

        <div className="mx-auto mt-7 max-w-3xl">
          {intro.body.map((line) => (
            <Lead key={line}>{line}</Lead>
          ))}
        </div>

        <Lead className="mx-auto mt-7 max-w-3xl">
          <Rich text={intro.lead} strong={[intro.leadStrong]} />
        </Lead>
      </Container>
    </Section>
  );
}
